// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"db05fde8","703":"752862c6"}[chunkId] + ".chunk.js";
};